import { z } from 'zod';

/**
 * A new support ticket. Mirrors `backend/src/modules/support/support.validation.ts`,
 * which is the authority — this is for fast feedback only (CLAUDE.md §6).
 */
export const newTicketSchema = z.object({
  subject: z
    .string()
    .trim()
    .min(5, 'Give the ticket a short subject')
    .max(150, 'Keep the subject under 150 characters')
    .refine((value) => !/[\r\n]/.test(value), 'The subject must be a single line'),
  category: z.enum(['TECHNICAL', 'BILLING', 'FEATURE_REQUEST', 'ACCOUNT', 'DATA_CORRECTION', 'OTHER'], {
    errorMap: () => ({ message: 'Choose what this is about' }),
  }),
  priority: z.enum(['LOW', 'NORMAL', 'HIGH', 'URGENT']),
  message: z
    .string()
    .trim()
    .min(1, 'Describe the problem')
    .max(5000, 'Keep the message under 5,000 characters'),
});

export type NewTicketPayload = z.infer<typeof newTicketSchema>;
